// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"_c57b4bf","header":"_4f2b9db","alert":"_aa9c51c","secondaryText":"_a81fb3c"};